import styled from 'styled-components'

export const ViewCommentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const ViewCommentsLink = styled.span`
  color: ${({ theme }) => theme.colors.text};
`

export const CommentsButton = styled.button`
  color: ${({ theme }) => theme.colors.text};
  width: 100%;
  padding: 16px;
  border: none;
  cursor: pointer;
  background: none;
`
